import { z, type infer as zInfer } from "zod";
import { market } from "hooks/firestore/v2/models/market";
import { timestamp } from "hooks/firestore/v2/models/timestamp";
import {
  promotionCampaign,
  type PromotionCampaign,
} from "hooks/firestore/v2/models/promotionCampaign";

export const bettingEvent = z.object({
  activeMarketCount: z.number(),
  activeMarketCounts: z.object({
    SameEventMulti: z.number(),
    SingleOutcome: z.number(),
  }),
  attributes: z.record(z.string(), z.any()).optional(),
  competitors: z
    .record(
      z.string(),
      z.object({
        abbreviation: z.string().optional(),
        name: z.string(),
        type: z.enum(["PLAYER", "FRANCHISE", "RACER"]),
        nationality: z.string().optional(),
        iconUri: z.string().optional(),
      }),
    )
    .optional(),
  eventId: z.string(),
  eventName: z.string(),
  eventType: z.enum(["MATCH", "SEASON", "TOURNAMENT"]),
  filters: z.array(z.string()),
  hub: z.enum(["sports", "esports"]),
  mainMarket: market.optional(),
  nextBetStop: timestamp.optional(),
  parentEventFilter: z.string(),
  parentEventName: z.string(),
  campaignIds: z.array(z.string()).optional(),
  hasPromotionalMarkets: z.boolean().optional(),
  promotionCampaigns: z.array(promotionCampaign).nullish(),
  relatedEventIds: z
    .record(z.string(), z.enum(["MATCH", "SEASON", "TOURNAMENT"]))
    .optional(),
  scheduledStartTime: z.string(),
  sport: z.string(),
  sportCategory: z.enum(["CONVENTIONAL", "ESPORTS"]),
  tab: z.enum(["next", "outrights"]),
  tournamentId: z.string().optional(),
  seasonId: z.string().optional(),
  visible: z.boolean(),
  streamUri: z.string().nullish(),
});

export type BettingEvent = zInfer<typeof bettingEvent>;
export type CampaignsType = PromotionCampaign;
